(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-product-rail]').forEach((rail) => {
    const track = rail.querySelector('[data-rail-track]');
    if (!track) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.82, 760), behavior: reducedMotion ? 'auto' : 'smooth' });
    rail.querySelector('[data-rail-prev]')?.addEventListener('click', () => move(-1));
    rail.querySelector('[data-rail-next]')?.addEventListener('click', () => move(1));
  });

  const hero = document.querySelector('[data-bubble-hero]');
  if (hero) {
    const updateProfileReminder = () => document.body.classList.toggle('has-scrolled', window.scrollY > Math.min(hero.offsetHeight * 0.72, 620));
    window.addEventListener('scroll', updateProfileReminder, { passive: true });
    updateProfileReminder();
  }
  if (hero && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
    hero.addEventListener('pointermove', (event) => {
      const x = (event.clientX / window.innerWidth - 0.5) * 10;
      const y = (event.clientY / window.innerHeight - 0.5) * 7;
      hero.style.setProperty('--hero-shift-x', `${x}px`);
      hero.style.setProperty('--hero-shift-y', `${y}px`);
    });
    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--hero-shift-x', '0px');
      hero.style.setProperty('--hero-shift-y', '0px');
    });
  }
})();
